import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { UserInvitationSummaryModel } from '../../typings';
import { GetLocalDateTimeString } from '../../DateUtilities';
import { invitationState } from './invitationHelpers';

interface InvitationChipProps {
    invited: boolean,
    invitation?: UserInvitationSummaryModel | null
}

const InvitationChip: React.FC<InvitationChipProps> = ({ invited, invitation }) => {
    const state = invitationState(invited, invitation);
    if (state === 'none' || !invitation) return null;

    if (state === 'not-sent') {
        return (
            <Tooltip title="The invitation was created, but no link has been issued yet.">
                <Chip label="Invite not sent" size="small" color="warning" variant="outlined" />
            </Tooltip>
        );
    }

    if (state === 'not-delivered' && invitation.lastDeliveryFailedUtc) {
        const failed = GetLocalDateTimeString(new Date(invitation.lastDeliveryFailedUtc));
        return (
            <Tooltip title={`The invitation email failed to send on ${failed}. Resend it to try again.`}>
                <Chip label="Invite not delivered" size="small" color="warning" variant="filled" />
            </Tooltip>
        );
    }

    const expires = invitation.expiresUtc ? GetLocalDateTimeString(new Date(invitation.expiresUtc)) : '';
    if (state === 'expired') {
        return (
            <Tooltip title={`The invitation expired ${expires}.`}>
                <Chip label="Invite expired" size="small" variant="outlined" />
            </Tooltip>
        );
    }

    return (
        <Tooltip title={`The invitation expires ${expires}.`}>
            <Chip label="Invited" size="small" color="info" variant="outlined" />
        </Tooltip>
    );
};

export default InvitationChip;
